export default function SvgMoneyBag() {
  return (
    <>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20px"
      cursor="pointer"
      viewBox="-9.5 0 67 67"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g stroke="#000" strokeWidth="2" transform="translate(1 3)">
          <path d="M14.4 2.6S24.5-4.3 26.1 6M25.4 3.2S27.2-.4 36 .1c0 2.8-2.6 9.9-6.5 11.2C39 16.9 46 33.5 46 43.5c0 12.1-9.3 18.6-22 18.6S0 55.6 0 43.5c0-9.9 6.9-26.6 16.5-32.2C12.6 10 10 2.9 10 .1 10 .1 14.4 4 20 4M16.4 11h14.7M31.1 12.3s11.2-.3 11.2 6M31.3 10.4s8.7.5 13.9-2.8"></path>
          <path d="M29.9 48.5c-1.4 1.6-3.2 2.5-5.2 2.5-4.3 0-7.7-4.3-7.7-9.7 0-5.3 3.5-9.3 7.7-9.3 2 0 3.7.6 5.1 2.1M14.1 38.9H26M13.1 43H25"></path>
        </g>
      </g>
    </svg>
    </>
  );
}
